export const PoolsAccessoriesSection = {
  title: 'Accessories',
  description:
    'The Compass Pools Rollo Cover chamber is integral part of your pool and contains an immerged mechanism with guiding wheels. When automatically opened or closed, the slats are smoothly guided and rolled around a stainless steel roller. The slats are powered by a sophisticated in-roller motor installed in the cover chamber. When opened, the cover slats are invisibly submerged below the water level behind a fixed panel in the same colour as the pool.',
  compasRolloCover: 'Compass rollo cover',
  copingStones: 'Coping stones',
};
